export default __webpack_public_path__ + "static/media/6.308a30bb.png";